import "./navbar.css";
import logo from "../../assets/navbarAssets/Ellipse 7.svg";
import { IoCallOutline } from "react-icons/io5";
import { useState, useRef, useEffect } from "react";

const Navbar = () => {
  const [isActive, setIsActive] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setIsActive(!isActive);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsActive(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <nav className="nav-bar" ref={menuRef}>
      <div className="nav-container">
        <div className="logo-title">
          <a href="#home">
            <img
              src={logo}
              alt="Logo"
              style={{ marginRight: "10px", marginLeft: "12px" }}
            />{" "}
          </a>
          <h2 className="nav-title">Saraswati Pathashala</h2>
          <div
            className={`hamburger ${isActive ? "active" : ""}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <div className="hamburger-line"></div>
            <div className="hamburger-line"></div>
            <div className="hamburger-line"></div>
          </div>
        </div>
        <ul className={`nav-components-container ${isActive ? "active" : ""}`}>
          <li className="nav-component">
            <a
              href="#home"
              className="nav-component-anchor"
              onClick={() => setIsActive(false)}
            >
              Home
            </a>
          </li>
          <li className="nav-component">
            <a
              href="#about"
              className="nav-component-anchor"
              onClick={() => setIsActive(false)}
            >
              About
            </a>
          </li>
          <li className="nav-component">
            <a
              href="#courses"
              className="nav-component-anchor"
              onClick={() => setIsActive(false)}
            >
              Courses
            </a>
          </li>
          <li className="nav-component">
            <a
              href="#admission"
              className="nav-component-anchor"
              onClick={() => setIsActive(false)}
            >
              Admission
            </a>
          </li>
          <li className="nav-component">
            <a
              href="#testimonials"
              className="nav-component-anchor"
              onClick={() => setIsActive(false)}
            >
              Testimonials
            </a>
          </li>
          <li className="nav-component">
            <a
              href="#contact"
              className="nav-component-anchor"
              onClick={() => setIsActive(false)}
            >
              Contact
            </a>
          </li>
          <li className="nav-component">
            <a
              href="tel:+917090354555"
              className="nav-call-icon-number"
              onClick={() => setIsActive(false)}
            >
              <IoCallOutline style={{ marginRight: "2px" }} />
              +91 70903 54555
            </a>
          </li>
          <li className="nav-component">
            <a href="tel:+919876543210">
              <button
                className="nav-demo-button"
                onClick={() => setIsActive(false)}
              >
                Book Demo Class
              </button>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
